'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { isSerieEmpty } from '@/components/charts/helpers/highcharts';
import { DashboardClass } from '@/contexts/Dashboard/Dashboard.context';
import { CardDashboardChart } from './CardDashboardChart';
import { CardDashboardHeader, type CardDashboardHeaderProps } from './CardDashboardHeader';
export type CardDashboardProps = CardDashboardHeaderProps & {
  testId?: string;
};
const CardDashboard = t0 => {
  const $ = _c(31);
  const {
    title,
    titleExtra,
    totalSlot,
    state,
    isFilterDisabled,
    hideSizeButton,
    testId
  } = t0;
  const isChartVisible = state.isSmall || state.isExpanded;
  const [shouldRenderChart, setShouldRenderChart] = useState(state.isSmall);
  if (state.isSmall && !shouldRenderChart) {
    setShouldRenderChart(true);
  }
  const [mountedExpanded, setMountedExpanded] = useState(state.isExpanded);
  if (mountedExpanded && !state.isExpanded) {
    setMountedExpanded(false);
  }
  const withAnimation = !mountedExpanded;
  let t1;
  let t2;
  if ($[0] !== isChartVisible || $[1] !== mountedExpanded || $[2] !== state.isSmall) {
    t1 = () => {
      if (isChartVisible && !state.isSmall) {
        const delay = mountedExpanded ? 0 : 200;
        const timer = setTimeout(() => {
          setShouldRenderChart(true);
        }, delay);
        return () => {
          clearTimeout(timer);
          setShouldRenderChart(false);
        };
      }
    };
    t2 = [isChartVisible, state.isSmall, mountedExpanded];
    $[0] = isChartVisible;
    $[1] = mountedExpanded;
    $[2] = state.isSmall;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== state.data) {
    t3 = state.data ?? [];
    $[5] = state.data;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = isSerieEmpty(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const hasData = !t4;
  let t5;
  if ($[9] !== hideSizeButton || $[10] !== isFilterDisabled || $[11] !== state || $[12] !== title || $[13] !== titleExtra || $[14] !== totalSlot) {
    t5 = <CardDashboardHeader title={title} titleExtra={titleExtra} totalSlot={totalSlot} state={state} isFilterDisabled={isFilterDisabled} hideSizeButton={hideSizeButton} />;
    $[9] = hideSizeButton;
    $[10] = isFilterDisabled;
    $[11] = state;
    $[12] = title;
    $[13] = titleExtra;
    $[14] = totalSlot;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== hasData || $[17] !== isChartVisible || $[18] !== shouldRenderChart || $[19] !== state.data || $[20] !== state.error || $[21] !== state.isLoading || $[22] !== state.isSmall || $[23] !== withAnimation) {
    t6 = isChartVisible && shouldRenderChart ? <motion.div key="card-dashboard-chart" layout={true} initial={withAnimation ? {
      opacity: 0,
      z: 0
    } : undefined} animate={{
      opacity: 1,
      transition: {
        delay: withAnimation ? 0.2 : 0
      }
    }} className={cn(DashboardClass.PREVENT_DASHBOARD_CARD_HOVER_CLASS, state.isSmall && "h-[322px] max-md:h-[200px]")} exit={{
      opacity: 0,
      z: 0,
      height: 0
    }} transition={{
      duration: 0.2
    }} style={{
      height: state.isSmall ? undefined : "100%",
      width: "100%",
      display: "flex"
    }}><CardDashboardChart data={hasData ? state.data : undefined} statuses={{
        loading: state.isLoading,
        error: state.error
      }} variant="default" className={DashboardClass.PREVENT_DASHBOARD_CARD_HOVER_CLASS} /></motion.div> : null;
    $[16] = hasData;
    $[17] = isChartVisible;
    $[18] = shouldRenderChart;
    $[19] = state.data;
    $[20] = state.error;
    $[21] = state.isLoading;
    $[22] = state.isSmall;
    $[23] = withAnimation;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t6) {
    t7 = <AnimatePresence mode="sync" initial={false}>{t6}</AnimatePresence>;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t5 || $[28] !== t7 || $[29] !== testId) {
    t8 = <Card className="gap-lg grow flex-col bg-transparent shadow-none" padding="none" data-testid={testId}>{t5}{t7}</Card>;
    $[27] = t5;
    $[28] = t7;
    $[29] = testId;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};
export default CardDashboard;